module.exports = __webpack_public_path__ + "img/asset-tier-1.4c37ca08.svg";